<template>
  <div class="not-found-container">
    <div class="not-found-content">
      <!-- ตัวอย่างใส่ภาพ/ไอคอน -->
      <img
        src="https://cdn-icons-png.flaticon.com/512/580/580185.png"
        alt="not found"
        class="not-found-image"
      />

      <!-- ข้อความหลัก -->
      <h1>404</h1>
      <p class="sub-title">Page Not Found</p>

      <!-- ข้อความเสริม -->
      <p class="detail">The page you're looking for doesn't exist, or has been moved.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound",
};
</script>

<style scoped>
.not-found-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh; /* ให้สูงเต็มจอ */
  background-color: #252525; /* พื้นหลังสีเข้มตามที่คุณชอบ */
  color: #fff; /* ตัวอักษรสีขาว */
  font-family: "Roboto", sans-serif; /* หรือฟอนต์อื่นๆ */
}

.not-found-content {
  text-align: center;
  max-width: 500px;
  padding: 2rem;
}

.not-found-image {
  max-width: 150px;
  margin-bottom: 1rem;
}

h1 {
  font-size: 5rem;
  margin: 0;
  font-weight: 900;
}

.sub-title {
  font-size: 1.5rem;
  margin: 0.5rem 0 1rem;
}

.detail {
  color: #bbb;
  margin-bottom: 2rem;
}

.back-home-button {
  display: inline-block;
  padding: 0.75rem 1.5rem;
  background: #ff6b6b; /* สีปุ่ม */
  color: #fff;
  text-decoration: none;
  border-radius: 4px;
  font-weight: bold;
  transition: background 0.3s ease;
}

.back-home-button:hover {
  background: #f05353; /* เปลี่ยนสีปุ่มเล็กน้อยเวลา hover */
}
</style>
